var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "d-md-none slide-popin-modal" },
      [
        _c(
          "slide-popin-modal-filter",
          {
            attrs: {
              id: "slide-filters-reviews-modal",
              "aria-labelledby": "slide-filters-reviews",
              "with-close-button": false,
            },
          },
          [
            _c("device-filter-reviews", {
              attrs: {
                device: "mobile",
                loading: _vm.deviceFilterReviews.loading,
                "reviews-messages": _vm.reviewsMessages,
                "ratings-filter-check-boxes": _vm.ratingsFilterCheckboxes,
                "date-sort-radio-buttons": _vm.dateSortRadioButtons,
              },
              on: {
                "change-check-box-ratings-filter":
                  _vm.updateRatingsFilterHandler,
                "review-date-sort-item-click": _vm.reviewDateSortHandler,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-12 col-md-4 col-lg-3" }, [
      _c(
        "div",
        { staticClass: "d-none d-md-block" },
        [
          _c("device-filter-reviews", {
            attrs: {
              device: "desktop",
              loading: _vm.deviceFilterReviews.loading,
              "reviews-messages": _vm.reviewsMessages,
              "ratings-filter-check-boxes": _vm.ratingsFilterCheckboxes,
              "date-sort-radio-buttons": _vm.dateSortRadioButtons,
            },
            on: {
              "change-check-box-ratings-filter": _vm.updateRatingsFilterHandler,
              "review-date-sort-item-click": _vm.reviewDateSortHandler,
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12 col-md-8 col-lg-9" },
      [
        _c("device-details-reviews", {
          attrs: {
            "total-review-count": _vm.totalReviewCount,
            "device-reviews": _vm.deviceDetailsReviews.reviews,
            loading: _vm.deviceDetailsReviews.loading,
            "reviews-messages": _vm.reviewsMessages,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-12" }, [
      _vm.hasMoreReviews
        ? _c("div", { staticClass: "row text-center mt-1" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("ob1-boutons", {
                  attrs: {
                    "is-button": true,
                    label: _vm.reviewsMessages.more,
                    "is-secondary": true,
                  },
                  on: { "ob1-boutons-click": _vm.getMoreDeviceReviews },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }